/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TopOfBookTrackFileRequest {
  timestamp: string;
  topOfBookSource?: number;
  /**
   * Use /lp endpoint instead.
   * @deprecated
   */
  lpPair?: number;
  /**
   * Use /market-making endpoint instead.
   * @deprecated
   */
  basePairId?: number;
  /**
   * Use /market-making endpoint instead. Eg. OKX or kaali_OKX.
   * @deprecated
   */
  platform?: string;
}
